module.exports = __webpack_public_path__ + "static/media/cv.ff0a8c1c.pdf";